import './AppleSignInButton.scss';

import { useEffect, useState } from 'react';
import AppleSignin from 'react-apple-signin-auth';

/** Apple Signin button */
const AppleSignInButton = ({ baseRedirectionUrl, onSuccess, onError = undefined }) => {
  const [safeRedirectionUrl, setSafeRedirectionUrl] = useState(
    baseRedirectionUrl.replace(/\/$/, '')
  );

  useEffect(() => {
    setSafeRedirectionUrl(baseRedirectionUrl.replace(/\/$/, ''));
  }, [baseRedirectionUrl, setSafeRedirectionUrl]);
  return (
    <AppleSignin
      /** Auth options passed to AppleID.auth.init() */
      authOptions={{
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID,
        scope: 'email',
        /** Apple's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
        redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
        /** Nonce */
        nonce: `${safeRedirectionUrl}?nonce=${Math.random()}&apple_token=`,
        /** Uses popup auth instead of redirection */
        usePopup: false
      }} // REQUIRED
      /** General props */
      uiType="light"
      /** className */
      className="apple-auth-btn"
      /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
      onSuccess={onSuccess} // default = undefined
      /** Called upon signin error */
      onError={onError} // default = undefined
    />
  );
};

export default AppleSignInButton;
